<template>
    <el-popover @show="onShowPopover" @hide="onHidePopover" ref="popoverObj" placement="bottom-start" width="380" trigger="click">
        <el-input style="width: 180px;" slot="reference" :readonly="true" placeholder="请选择" v-model="showValue">
          <i slot="prefix" class="el-input__icon el-icon-date"></i>
        </el-input>
        <dimension v-if="isShowDiv" :autoChunkMonth="autoChunkMonth" :tabNames="tabNames" :openType="'popover'" :showBottomButton="showBottomButton" :isSingleSelect="true" :dimObj="dimObj" :isMapValue="isMapValue" :isItemBindClick="isItemBindClick" :clickItem="clickItem" :okLabel="'确认'" />
    </el-popover>
</template>

<script>
import dimension from './index.vue'
import get from 'lodash/get'
import { getDimensionDescLabel } from "./components/util.js"
export default {
  props: {
    autoChunkMonth: {//自动拆分月
      type: Boolean,
      default: false
    },
    tabNames: {//容许 显示的tab name
      type: String,
      default: 'monthly|quarterly|semi-annual|annual'
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    isItemBindClick: {
      type: Boolean,
      default: false
    },
    isMapValue: {
      type: Boolean,
      default: false
    },
    dimObj: {
      type: Object,
      default(){
        return {
          "year":new Date().getFullYear(),
          "month":'01',
          "type":'0'
        }
      },
    },
    change: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    let showValue = getDimensionDescLabel(this.dimObj)
    return {
      showValue,
      isShowDiv:false,
    }
  },
  components: {
    dimension,
  },
  methods: {
    onHidePopover(){
      this.isShowDiv=false;
    },
    onShowPopover(){
      this.isShowDiv=true;
    },
    clickItem(e){
      this.$refs.popoverObj.doClose();
      let isOk = get(e,"isOk",false);
      if(isOk){
        this.showValue = e.labels;
        this.change(e);
      }
    },
    setCtrlValue(){
      console.log(this.dimObj)
      this.showValue = getDimensionDescLabel(this.dimObj)
    }
  },
}
</script>
